import '../styles/ResultsMasthead.css';
import React, { useState } from 'react';
import { useProjectCollection } from '../lib/projectData';

const FALLBACK_RUN_ID = 'run-2026-02-11-01';
const STATE_LABEL = {
  complete: 'complete',
  failed: 'failed',
  running: 'running',
  idle: 'idle',
};
const STATE_CLASS = {
  complete: 'rem-state--pass',
  failed: 'rem-state--fail',
  running: 'rem-state--running',
};

function readRunId() {
  if (typeof window === 'undefined') return FALLBACK_RUN_ID;
  try {
    const params = new URLSearchParams(window.location.search);
    const id = params.get('id');
    return id && id.trim() ? id.trim() : FALLBACK_RUN_ID;
  } catch (err) {
    return FALLBACK_RUN_ID;
  }
}

function Sticker() {
  return (
    <span className="rem-sticker">
      <span className="rem-sticker-dot" aria-hidden="true" />
      AUTHORIZED TARGET ONLY
    </span>
  );
}

function Routes({ runId, className }) {
  return (
    <ul className={`rem-routes ${className || ''}`.trim()} aria-label="Results routes">
      <li>
        <a className="rem-route" href={`/run-monitor?id=${encodeURIComponent(runId)}`}>
          <span>Return to Run Monitor</span>
          <span className="rem-route-arrow" aria-hidden="true">→</span>
        </a>
      </li>
      <li>
        <a className="rem-route" href="/dashboard">
          <span>Return to Dashboard</span>
          <span className="rem-route-arrow" aria-hidden="true">→</span>
        </a>
      </li>
      <li>
        <a className="rem-route" href="/history">
          <span>Open History</span>
          <span className="rem-route-arrow" aria-hidden="true">→</span>
        </a>
      </li>
    </ul>
  );
}

export default function ResultsMasthead() {
  const [runId] = useState(readRunId);
  const { data: runData, error: runError } = useProjectCollection('test_run');
  const failed = Boolean(runError);

  const source = runData || null;
  const run = Array.isArray(source)
    ? source.find((r) => r && r.id === runId) || source.find((r) => r && r.id === FALLBACK_RUN_ID) || null
    : null;

  const stateKey = run && typeof run.state === 'string' ? run.state.toLowerCase() : '';

  return (
    <section className="rem-root" aria-labelledby="results-masthead-title">
      <div className="rem-foot-rule">
        <div className="rem-inner" data-content-rail="workspace">
          <div className="rem-lead">
            <p className="rem-eyebrow">Run results</p>
            <h1 className="rem-title" id="results-masthead-title">
              Results
              <span className="rem-title-underline" aria-hidden="true" />
            </h1>
            <p className="rem-run">
              {run ? (
                <>
                  <span className="rem-run-name">{run.name}</span>
                  <span className="rem-run-sep" aria-hidden="true">—</span>
                  <span className="rem-run-mono">{run.target}</span>
                  <span className="rem-run-sep" aria-hidden="true">—</span>
                  <span className={`rem-state ${STATE_CLASS[stateKey] || ''}`.trim()}>
                    {STATE_LABEL[stateKey] || run.state}
                  </span>
                </>
              ) : (
                <span className="rem-none">
                  {failed ? 'Run details unavailable' : 'Loading run details…'}
                </span>
              )}
            </p>
          </div>

          <div className="rem-cluster">
            <Sticker />
            <Routes runId={run && run.id ? run.id : runId} />
          </div>

          <Routes runId={run && run.id ? run.id : runId} className="rem-routes--row" />
        </div>
      </div>
    </section>
  );
}